
































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  MelosStation,
  MelosTrack,
  MelosPodcast,
  MelosContentOrder,
  MelosContentType,
  MelosStationType,
} from '@/services/api.service';
import MelosSquareButton from '@/components/MelosSquareButton.vue';
import fo from '@/assets/1o.svg';
import vynil from '@/assets/vynil.svg';
import genericStation from '@/assets/station.svg';
import MelosInput from '@/components/MelosInput.vue';
import MelosButtonSet from '@/components/MelosButtonSet.vue';

@Component({
  components: {
    MelosSquareButton,
    MelosInput,
    MelosButtonSet,
  },
})
export default class MelosContentCollection extends Vue {
  private collectionUri: string = '/home/collection';
  private loading: boolean = false;
  private loadingPercentage: number = 0;

  private async mounted() {
    if (this.stations.length === 0 && this.tracks.length === 0) {
      await this.fetchContent();
    }
    const scrollOffset = 60;
    if (this.$refs.stationGrid !== undefined) (this.$refs.stationGrid as any).scrollLeft = scrollOffset;
    if (this.$refs.trackGrid !== undefined) (this.$refs.trackGrid as any).scrollLeft = scrollOffset;
  }

  private get stations(): MelosStation[] {
    return this.$store.state.ownedStations || [];
  }

  private get tracks(): MelosTrack[] {
    return this.$store.state.ownedTracks || [];
  }

  private get podcasts(): MelosPodcast[] {
    return this.$store.state.ownedPodcasts || [];
  }

  private get uriTime(): number {
    return this.$store.state.uriTime;
  }

  private async askForPodcastLink() {
    const uri = await (this as any).$ons.notification.prompt('Enter podcast URI');
    if (uri === undefined || uri === '') {
      return;
    }
    return this.addNewPodcast(uri);
  }

  private async addNewPodcast(uri: string) {
    await this.$apiService.addPodcast({
      title: 'My new podcast',
      uri,
      tags: [],
    });
    return this.fetchContent();
  }

  private async onInputChange() {
    const files = ((this.$refs.trackInput as any).files || []);
    this.loading = true;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      this.loadingPercentage = 100 * i / files.length;
      await this.uploadTrack(file.name, file);
    }
    this.loading = false;
    return this.fetchContent();
  }

  private async uploadTrack(fileName: string, file: any) {
    const title = (fileName.match(/(.*)(.ogg)/i) || ['', '-'])[1];
    return this.$apiService.uploadTrack({
      fileName,
      title,
      tags: [],
    }, file);
  }

  private async createNewStation() {
    await this.$apiService.createStation({
      name: 'Pop time!',
      type: MelosStationType.PRIVATE,
      period_config: [{
        start: '000000',
        end: '235959',
        content: [{
          name: 'Pop',
          type: MelosContentType.TAG_BASED,
          tag: 'pop',
          provider: 'jamendo',
          weight: 1,
        }],
        content_order: MelosContentOrder.WEIGHT_BASED,
      }],
    });
    return this.fetchContent();
  }

  private selectAll() {
    this.checkedItems = [];
    if (this.content === 'tracks' || this.content === '') {
      this.trackList.forEach((track) => this.checkedItems.push(track.id || ''));
    }
    if (this.content === 'stations' || this.content === '') {
      this.stationList.forEach((station) => this.checkedItems.push(station._id || ''));
    }
    if (this.content === 'podcasts' || this.content === '') {
      this.podcastList.forEach((podcast) => this.checkedItems.push(podcast._id || ''));
    }
  }

  private get checkedItems(): string [] {
    return this.$store.state.checkedItems || [];
  }

  private set checkedItems(itemList: string[]) {
    this.$store.commit('setCheckedItems', itemList);
  }

  private onStateUpdate(state: boolean, id: string) {
    if (state) {
      this.checkedItems.push(id);
    } else {
      this.checkedItems.splice(this.checkedItems.indexOf(id), 1);
    }
  }

  private get optionLabels(): string [] {
    const labels = [];
    if (this.checkedItems.length < (this.stationList.length + this.trackList.length)) {
      labels.push('DOUBLE');
    }
    if (this.checkedItems.length > 0) {
      labels.push('x');
    }
    if (this.checkedItems.length > 0 && this.multiSelectionAllowed()) {
      labels.push('EDIT');
    }
    if (this.checkedItems.length > 0) {
      labels.push('trash');
    }
    return labels;
  }

  private multiSelectionAllowed(): boolean {
    const stationSelected = this.stationList.findIndex((station) => {
      return this.checkedItems.includes(station._id || '');
    }) !== -1;
    if (stationSelected) {
      return false;
    }
    return this.podcastList.findIndex((podcast) => {
      return this.checkedItems.includes(podcast._id || '');
    }) === -1;
  }

  private async removeAllSelectedItems() {
    const selectedStations = this.stationList.filter((stationData) => {
      return this.checkedItems.includes(stationData._id || '');
    });
    const selectedTracks = this.trackList.filter((trackData) => {
      return this.checkedItems.includes(trackData.id || '');
    });
    const selectedPodcasts = this.podcastList.filter((podcastData) => {
      return this.checkedItems.includes(podcastData._id || '');
    });

    for (const station of selectedStations) {
      await this.$apiService.removeStation(station._id || '');
    }

    for (const track of selectedTracks) {
      await this.$apiService.removeTrack(track.id || '');
    }

    for (const podcast of selectedPodcasts) {
      await this.$apiService.removePodcast(podcast._id || '');
    }

    this.checkedItems = [];

    return this.fetchContent();
  }

  private onOptionClick(index: number) {
    const option: string = this.optionLabels[index] || '';
    switch (option) {
    case 'DOUBLE':
      this.selectAll();
      break;
    case 'x':
      this.checkedItems = [];
      break;
    case 'EDIT':
      this.$router.push('/tracks/multiple');
      break;
    case 'trash':
      (this as any).$ons.notification.confirm('Are you sure you want to delete the selected items?')
      .then((response: number) => response === 1 ? this.removeAllSelectedItems() : undefined);
      break;
    }
  }

  private loggedIn(): boolean {
    return !!this.$sessionService.getSessionData() &&
    this.$sessionService.getSessionData().token !== '';
  }

  private get token(): string {
    return this.$store.state.session?.token || '';
  }

  private async fetchContent() {
    if (!this.loggedIn()) {
      return;
    }
    const ownedStations = (await this.$apiService.getStations())
   .filter((station) => station.owner === this.$store.state.session?.userId);
    const ownedTracks = await this.$apiService.getTracks();
    const ownedPodcasts = await this.$apiService.getPodcasts();
    this.$store.commit('setOwnedStations', ownedStations);
    this.$store.commit('setOwnedTracks', ownedTracks);
    this.$store.commit('setOwnedPodcasts', ownedPodcasts);
  }

  private applyFilter(content: any) {
    const expression = new RegExp(`${this.filterQuery}`, 'i');

    if (expression.test(content.title || content.name) || expression.test(content.artist || '')) {
      return true;
    }

    return (content.tags || []).findIndex((tag: string) => expression.test(tag)) !== -1;
  }

  private get stationList(): MelosStation[] {
    return this.stations.filter((station) => this.applyFilter(station));
  }

  private get trackList(): MelosTrack[] {
    return this.tracks.filter((track) => this.applyFilter(track));
  }

  private get podcastList(): MelosPodcast[] {
    return this.podcasts.filter((podcast) => this.applyFilter(podcast));
  }

  private getStationFallbackImage(station: any) {
    return genericStation;
  }

  private getTrackFallbackImage(station: any) {
    return vynil;
  }

  private get stationsLink(): string {
    if (this.content !== '') {
      return `${this.collectionUri}?filterQuery=${this.filterQuery}`;
    }
    return `${this.collectionUri}?content=stations&filterQuery=${this.filterQuery}`;
  }

  private get tracksLink(): string {
    if (this.content !== '') {
      return `${this.collectionUri}?filterQuery=${this.filterQuery}`;
    }
    return `${this.collectionUri}?content=tracks&filterQuery=${this.filterQuery}`;
  }

  private get podcastsLink(): string {
    if (this.content !== '') {
      return `${this.collectionUri}?filterQuery=${this.filterQuery}`;
    }
    return `${this.collectionUri}?content=podcasts&filterQuery=${this.filterQuery}`;
  }

  private get content(): string {
    return String(this.$route.query.content || '');
  }

  private get filterQuery(): string {
    return String(this.$route.query.filterQuery || '');
  }

  private set filterQuery(text: string) {
    this.$router.replace({ path: this.collectionUri, query: { ...this.$route.query, filterQuery: text }});
  }
}
